const API_BASE = window.FreeSampleConfig.apiBase;

document.addEventListener("DOMContentLoaded", () => {

    let sampleProducts = [];
    let publicSettings = {};

    const form = document.getElementById("claim-form");

    if (!form) return;

    const flavorSelect = document.getElementById("flavor");
    const strengthSelect = document.getElementById("strength");
    const variantInput = document.getElementById("variant-id");

    const submitButton = form.querySelector(".submit-btn");

    /*====================================
        Address Fields
    ====================================*/

    const countryEl = document.getElementById("country");
    const zipEl = document.getElementById("zip");

    strengthSelect.disabled = true;

    /*====================================
        Show Success / Error Message
    ====================================*/

    function showMessage(message, type = "success") {

        let box = document.querySelector(".form-message");

        if (!box) {

            box = document.createElement("div");

            box.className = "form-message";

            form.prepend(box);

        }

        box.classList.remove("success", "error", "show");

        box.classList.add("form-message", type, "show");

        box.textContent = message;

        box.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });

    }

    async function loadPublicSettings() {

        try {

            const response = await fetch(
                `${API_BASE}/settings/public`
            );

            const result = await response.json();

            publicSettings = result.settings || {};

            if (String(publicSettings.form_enabled) !== "true") {

                form.style.display = "none";

                const message =
                    document.getElementById("form-disabled-message");

                message.style.display = "block";

                message.classList.add("show");

                message.textContent =
                    publicSettings.out_of_stock_message;

                return false;

            }

            document.getElementById("marketing").checked =
                String(publicSettings.marketing_checked) === "true";

            const ageGroup =
                document.querySelector(".age-group");

            if (
                String(publicSettings.require_age_confirmation) !== "true"
            ) {

                ageGroup.style.display = "none";

            }

            submitButton.textContent =
                publicSettings.submit_button_text;

            return true;

        } catch (error) {

            console.error(error);

            return true;

        }

    }

    /*====================================
        Load Products
    ====================================*/

    async function loadProducts() {

        try {

            const response = await fetch(`${API_BASE}/products`);

            const result = await response.json();

            sampleProducts = Array.isArray(result)
                ? result
                : result.products || [];

            if (!sampleProducts.length) {

                form.innerHTML = `
                    <div class="form-message error show">
                        ${publicSettings.out_of_stock_message}
                    </div>
                `;

                return;

            }

            flavorSelect.innerHTML =
                `<option value="">Select Flavour *</option>`;

            sampleProducts.forEach(product => {

                const option = document.createElement("option");

                option.value = product.productId;

                option.textContent = product.flavor;

                flavorSelect.appendChild(option);

            });

        } catch (error) {

            showMessage(
                "Unable to load sample products.",
                "error"
            );

        }

    }

    /*====================================
        Flavor Changed
    ====================================*/

    flavorSelect.addEventListener("change", () => {

        strengthSelect.innerHTML =
            `<option value="">Select Strength *</option>`;

        strengthSelect.disabled = true;

        variantInput.value = "";

        const product = sampleProducts.find(

            p => p.productId === flavorSelect.value

        );

        if (!product) return;

        product.strengths.forEach(strength => {

            if (!strength.available) return;

            const option = document.createElement("option");

            option.value = strength.variantId;

            option.textContent = strength.strength;

            strengthSelect.appendChild(option);

        });

        strengthSelect.disabled = false;

    });

    /*====================================
        Strength Changed
    ====================================*/

    strengthSelect.addEventListener("change", () => {

        variantInput.value = strengthSelect.value;

    });

    /*====================================
        Submit Form
    ====================================*/
    function showSuccessScreen(result) {

        document.querySelector(".form-wrapper").style.display = "none";

        document.querySelector(".claim-success-wrapper").style.display = "block";

        document.getElementById("result-order-id").textContent =
            result.orderName || "-";

        document.getElementById("result-customer-name").textContent =
            `${result.firstName} ${result.lastName}`;

        document.getElementById("result-flavor").textContent =
            result.flavor || "-";

        document.getElementById("result-strength").textContent =
            result.strength || "-";

        document.getElementById("result-address").textContent =
            result.shippingAddress || "-";

        document.getElementById("result-shipping-date").textContent =
            result.shippingMethod || "-";

    }

    form.addEventListener("submit", async (event) => {

        event.preventDefault();

        if (!variantInput.value) {

            showMessage(
                "Please select a flavour and strength.",
                "error"
            );

            return;

        }

        const age = document.querySelector(
            'input[name="age"]:checked'
        )?.value;

        if (age !== "yes") {

            showMessage(
                "You must be 18 years or older to claim a free sample.",
                "error"
            );

            return;

        }

        submitButton.disabled = true;

        submitButton.classList.add("loading");

        const payload = {

            firstName:
                document.getElementById("first_name").value.trim(),

            lastName:
                document.getElementById("last_name").value.trim(),

            email:
                document.getElementById("email").value.trim(),

            phone:
                document.getElementById("phone").value.trim(),

            address:
                document.getElementById("address").value.trim(),

            country:
                document.getElementById("country").value,

            state: "N/A",

            city:
                document.getElementById("city").value,

            zip:
                document.getElementById("zip").value.trim(),

            variantId:
                variantInput.value,

            age,

            marketing:
                document.getElementById("marketing").checked

        };

        try {

            const response = await fetch(`${API_BASE}/claim`, {

                method: "POST",

                headers: {

                    "Content-Type": "application/json"

                },

                body: JSON.stringify(payload)

            });

            const result = await response.json();

            if (!response.ok) {

                throw new Error(

                    result.message ||

                    publicSettings.duplicate_message ||

                    result.error ||

                    (Array.isArray(result.errors)
                        ? result.errors.join(", ")
                        : "Something went wrong.")

                );

            }
            form.reset();
            showSuccessScreen(result);

            countryEl.value = window.FreeSampleConfig.countryName;

            flavorSelect.selectedIndex = 0;

            strengthSelect.innerHTML =
                `<option value="">Select Strength *</option>`;

            strengthSelect.disabled = true;

            variantInput.value = "";

        } catch (error) {

            showMessage(error.message, "error");

        } finally {

            submitButton.disabled = false;

            submitButton.classList.remove("loading");

        }

    });

    (async () => {

        const enabled =
            await loadPublicSettings();

        if (!enabled) return;

        loadProducts();

    })();

});